/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Ad_DescriptionInputs */



/**
* | output |
* | --- |
* | "Generate an AI-powered audio description script for the current video." |
*
* @param {Automatic_Ad_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_ad_description = /** @type {((inputs?: Automatic_Ad_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Ad_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Générer un script de description audio basé sur l'IA pour la vidéo actuelle.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Generieren Sie ein KI-gestütztes Audiobeschreibungsskript für das aktuelle Video.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Genera una descrizione audio basata sull'intelligenza artificiale per il video corrente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сгенерируйте скрипт аудиоописания для текущего видео с помощью искусственного интеллекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Genera un guion de audiodescripción con inteligencia artificial para el vídeo actual.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("为当前视频生成人工智能音频描述脚本。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の動画に対して、AIを活用した音声解説スクリプトを生成します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान वीडियो के लिए एआई-संचालित ऑडियो विवरण स्क्रिप्ट तैयार करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gere um roteiro de descrição de áudio com inteligência artificial para o vídeo atual.")
	return /** @type {LocalizedString} */ ("Generate an AI-powered audio description script for the current video.")
});